import { useState } from "react";
import ContactSalesModal from "./ContactSalesModal";
import { BillingAPI } from "@/api/billing";

const certifications = [
  { name: "Cyber Essentials", src: "/images/cyber-essentials.png" },
  { name: "TISAX", src: "/images/tisax.png" },
  { name: "ISO 27001", src: "/images/iso-27001.png" },
  { name: "ISO 27701", src: "/images/iso-27701.png" },
];

const Footer = () => {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <footer className="relative z-10 border-t border-border bg-transparent px-6 py-14">
      <div className="container mx-auto">
        <div className="flex flex-col gap-8 md:flex-row md:items-center md:justify-between">
          <div className="text-center md:text-left">
            <img src="/images/orbit8-logo.png" alt="ORbiT8" className="mx-auto h-7 w-auto md:mx-0" />
            <p className="mt-2 text-sm font-light text-muted-foreground">
              Open Source Risk Intelligence Platform
            </p>
          </div>

          <div className="flex flex-col items-center gap-4 md:items-end">
            <span className="text-xs font-semibold uppercase tracking-[0.18em] text-primary">
              Security &amp; Compliance Certifications
            </span>
            <div className="flex flex-wrap items-center justify-center gap-6 md:justify-end md:gap-10">
              {certifications.map((cert) => (
                <img
                  key={cert.name}
                  src={cert.src}
                  alt={cert.name}
                  title={cert.name}
                  className="h-14 w-auto object-contain transition-transform duration-300 hover:scale-105"
                />
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-border pt-6 sm:flex-row">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Orbit8. All Rights Reserved.
          </p>
          <div className="flex gap-6 text-xs text-muted-foreground">
            <a href="/terms-of-service" className="transition-colors duration-300 hover:text-primary">
              Terms &amp; Conditions
            </a>
            <a href="/privacy-policy" className="transition-colors duration-300 hover:text-primary">
              Privacy Policy
            </a>
            <a href="/gdpr-policy" className="transition-colors duration-300 hover:text-primary">
              GDPR Policy
            </a>
            <button
              type="button"
              onClick={() => setContactOpen(true)}
              className="transition-colors duration-300 hover:text-primary"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>

      <ContactSalesModal
        open={contactOpen}
        onOpenChange={setContactOpen}
        confirmOnSuccess
        onSubmit={async (data) => {
          await BillingAPI.publicContactSales({ ...data, source: "pricing" });
        }}
      />
    </footer>
  );
};

export default Footer;
